import { render, staticRenderFns } from "./indexMenu.vue?vue&type=template&id=f842d076&scoped=true"
import script from "./indexMenu.vue?vue&type=script&lang=js"
export * from "./indexMenu.vue?vue&type=script&lang=js"
import style0 from "./indexMenu.vue?vue&type=style&index=0&id=f842d076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f842d076",
  null
  
)

export default component.exports